export class ProjectPlanAPIModel {
  ProjectPlanAPI: string = "";
  ProjectPlanDetailsAPI: string = "";
  DeleteProjectPlan: string = "";
  GetScheduleAPI: string = "";
  UpdateProjectPlanningAPI: string = "";

  FailedMsg: string = "";
  DeleteTitle: string = "";
  DeleteText: string = "";
}
